import React, { useState } from "react";
import Select from 'react-select';
import axios from "axios";
//react-icons
import { IoMdRefreshCircle } from "react-icons/io";
//css
import "./DevicePage.css";
//components
import FetchLoader from "../../helpers/FetchLoader";
//properties
import { properties } from "../../helpers/properties";

const AssignDevice = ({ deviceList, fetchDevices, countryId, userSsoId, authToken }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDevice, setSelectedDevice] = useState("");
    const [selectedDeviceId, setSelectedDeviceId] = useState("");
    const [Error, setError] = useState(false);

    const handleDeviceSelect = (e) => {
        setSelectedDeviceId(e.deviceId);
        setSelectedDevice(e.deviceName);
    }

    const handleRefreshIcon = () => {
        fetchDevices();
    }

    const handleAssign = () => {
        setIsLoading(true);
        axios.put(process.env.REACT_APP_API_URL + `/v1/locations/${countryId}/devices/${selectedDeviceId}/assign/user/${userSsoId}`, '', {
            headers: { Authorization: `Bearer ${authToken}` }
        })
            .then((response) => {
                fetchDevices();
            })
            .catch((error) => {
                console.error("Error fetching devices:", error);
                setError(true);
                setIsLoading(false);
            });
    };



    return (
        <>
            <span className="device-info">
                <p>Please choose an available registered device from the list below to assign to yourself.<br></br>Devices displayed with a strikethrough are already assigned to another user and cannot be selected.</p>
                <p>If you don't see your physical device in the list, ensure it is turned ON and connected to the internet.<br></br> Then, refresh the list using the button below to see the latest available devices.</p>
            </span>

            <div className="form-group">
                <Select
                    className="device-dropdown"
                    placeholder="Select a device"
                    onChange={handleDeviceSelect}
                    options={deviceList}
                    styles={{
                        control: (baseStyles) => ({
                            ...baseStyles,
                            border: "1px solid #d1d5db",
                            borderRadius: "8px",
                            outline: "none",
                            boxShadow: "none",
                            "&:hover": {
                                borderColor: "#0abe75",
                            },
                            "&:focus": {
                                borderColor: "#0abe75",
                            },
                        }),
                        option: (styles, { data, isDisabled }) => {
                            return {
                                ...styles,
                                backgroundColor: "#fff",
                                textDecoration: isDisabled ? "line-through" : "none",
                                color: "#000",
                                "&:hover": {
                                    backgroundColor: isDisabled ? undefined : "#f0f0f0",
                                },
                                cursor: isDisabled ? "not-allowed" : "default",
                            };
                        },
                    }}
                />
                <span className="refresh-icon" onClick={handleRefreshIcon}><IoMdRefreshCircle color="#115c36" size="1.4em" /></span>
            </div>

            <div className="button-group">
                <button className={`assign-btn device-btn ${(selectedDevice) ? "" : "disabled-btn"}`} onClick={() => handleAssign(selectedDeviceId)}>
                    {isLoading ? <FetchLoader /> : <span>Assign to me</span>}
                </button>
            </div>
            {Error && <div className="error-message">{properties.DEVICE_ASSIGN_ERROR_MSG}</div>}
        </>
    );
};
export default AssignDevice;